'use client'

import { ABOUT_NAV } from '@/lib/nav'
import { track } from '@/lib/tracking'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { RiArrowDownSLine, RiInformationLine } from 'react-icons/ri'

// The pages about Pano (ABOUT_NAV), in one menu (2026-09-30). On desktop it's
// a dropdown at the end of the primary nav; on phones it's an info icon at
// the end of the bottom tab bar. Same list, same tracking, so the two never
// drift.
function items(location, skip = []) {
  return ABOUT_NAV.filter((item) => !skip.includes(item.href)).map((item) => (
    <MenuItem key={item.href}>
      <Link
        href={item.href}
        onClick={() =>
          track('nav_click', { href: item.href, label: item.label, location })
        }
        className="block px-3 py-2 font-sans text-sm text-foreground data-[focus]:bg-muted"
      >
        {item.label}
      </Link>
    </MenuItem>
  ))
}

export function AboutMenuDesktop() {
  const pathname = usePathname()
  const active = ABOUT_NAV.some(
    (i) => i.href !== '/sources' && pathname?.startsWith(i.href)
  )
  return (
    <Menu as="div" className="relative">
      <MenuButton
        className={`inline-flex items-center gap-0.5 py-1.5 font-sans text-sm text-foreground underline-offset-[6px] transition-colors ${
          active ? 'font-semibold underline' : 'hover:underline'
        }`}
      >
        About
        <RiArrowDownSLine className="h-4 w-4" aria-hidden="true" />
      </MenuButton>
      <MenuItems
        anchor="bottom start"
        className="z-50 mt-2 w-44 rounded-lg border border-foreground bg-card py-1 focus:outline-none"
      >
        {/* Sources is in the desktop bar itself (header B). */}
        {items('topbar_about', ['/sources'])}
      </MenuItems>
    </Menu>
  )
}

export function AboutMenuMobile() {
  const pathname = usePathname()
  const active = ABOUT_NAV.some((i) => pathname?.startsWith(i.href))
  return (
    <Menu as="div" className="relative flex-1">
      <MenuButton
        aria-label="About Pano"
        className={`flex min-h-[3.25rem] w-full flex-col items-center justify-center gap-0.5 font-sans text-[11px] transition-colors ${
          active
            ? 'font-semibold text-foreground'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        <RiInformationLine className="h-5 w-5" aria-hidden="true" />
        About
      </MenuButton>
      {/* Opens upward, above the tab bar. */}
      <MenuItems
        anchor="top end"
        className="z-50 mb-2 w-44 rounded-lg border border-foreground bg-card py-1 focus:outline-none"
      >
        {items('mobile_tab_bar_about')}
      </MenuItems>
    </Menu>
  )
}
